var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('a', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "title": "Email Preview",
      "target": "iframe_a"
    },
    on: {
      "click": function($event) {
        _vm.getEmailPreview()
      }
    }
  }, [(_vm.buttonType === 'button') ? _c('span', [_vm._v("Email Preview")]) : _vm._e(), _vm._v(" "), (_vm.buttonType === 'eye') ? _c('span', [_c('i', {
    staticClass: "fa fa-eye"
  })]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.closePreviewModal()
      }
    },
    model: {
      value: (_vm.isActiveLogModal),
      callback: function($$v) {
        _vm.isActiveLogModal = $$v
      },
      expression: "isActiveLogModal"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_vm._v("Email Message")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "display": "inline",
      "position": "relative",
      "bottom": "30px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closePreviewModal()
      }
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-table', {
    staticClass: "table-outline mb-0",
    attrs: {
      "sticky-header": "",
      "hover": "",
      "striped": "",
      "responsive": "sm",
      "outline": "",
      "fields": _vm.emailPreviewFields,
      "items": _vm.emailMessageArray,
      "head-variant": "default"
    },
    scopedSlots: _vm._u([{
      key: "show_details",
      fn: function(ref) {
        var detailsShowing = ref.detailsShowing;
        var item = ref.item;

        return [_c('b-btn', {
          on: {
            "click": function($event) {
              _vm.toggleDetails(item)
            }
          }
        }, [_vm._v(_vm._s(detailsShowing ? 'Hide' : 'Show'))])]
      }
    }, {
      key: "row-details",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row mb-4"
        }, [_c('div', {
          staticClass: "col-sm-4"
        }, [_c('div', [_c('b', [_vm._v("Email From :")]), _vm._v("\n                    " + _vm._s(item.fromid) + "\n                  ")])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-4"
        }, [_c('div', {
          staticClass: "col-sm-4"
        }, [_c('div', [_c('b', [_vm._v("Email To :")]), _vm._v("\n                    " + _vm._s(item.toid) + "\n                  ")])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-4"
        }, [_c('div', {
          staticClass: "col-sm-4"
        }, [_c('div', [_c('b', [_vm._v("Email CC :")]), _vm._v("\n                    " + _vm._s(item.cc) + "\n                  ")])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-4"
        }, [_c('div', {
          staticClass: "col-sm-4"
        }, [_c('b', [_vm._v("Email Subject :")]), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(item.subject)
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-4"
        }, [_c('div', {
          staticClass: "col-sm-4"
        }, [_c('b', [_vm._v("Email Body :")]), _vm._v(" "), _c('span', {
          staticClass: "test",
          domProps: {
            "innerHTML": _vm._s(item.emailbody)
          }
        })])])])]
      }
    }, {
      key: "emaildate",
      fn: function(item) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("dateFilter")(item.value)))])]
      }
    }, {
      key: "emailtype",
      fn: function(item) {
        return [(item.value.toLowerCase() == 'in') ? _c('span', [_vm._v("Received")]) : _vm._e(), _vm._v(" "), (item.value.toLowerCase() == 'out') ? _c('span', [_vm._v("Sent")]) : _vm._e()]
      }
    }, {
      key: "isattachment",
      fn: function(item) {
        return [_c('span', [(item.item.emailtype === 'in' && item.value && item.value && item.value.toLowerCase() === 'yes') ? _c('span', [_c('router-link', {
          attrs: {
            "to": {
              path: encodeURI('/emailattachment'),
              query: {
                inboxID: item.item.inboxid,
                caseID: item.item.caseid
              }
            },
            "id": "link",
            "title": "View Attachment",
            "target": "_blank"
          }
        }, [_c('a', [_vm._v("View Attachment")])])], 1) : _vm._e(), _vm._v(" "), (item.item.emailtype === 'out' && item.value && item.value && item.value.toLowerCase() === 'yes') ? _c('span', [_c('router-link', {
          attrs: {
            "to": {
              path: encodeURI('/emailattachment'),
              query: {
                outboxID: item.item.id,
                caseID: item.item.caseid
              }
            },
            "id": "link",
            "title": "View Attachment",
            "target": "_blank"
          }
        }, [_c('a', [_vm._v("View Attachment")])])], 1) : _vm._e(), _vm._v(" "), (item.value && item.value && item.value.toLowerCase() === 'no' || item.value === '') ? _c('span', [_vm._v("\n                  No\n              ")]) : _vm._e()])]
      }
    }]),
    model: {
      value: (_vm.currentItems),
      callback: function($$v) {
        _vm.currentItems = $$v
      },
      expression: "currentItems"
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-034321be","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/emailr/EmailPreview.vue
// module id = 902
// module chunks = 1